// Cut U18, issue #392: the shared date format constants.
//
// This module is the one place a date format changes. Every site that
// renders a date imports one of these three constants instead of carrying
// its own inline format string, so a format change happens in this file and
// nowhere else. The fresh count (task 1 of the plan, tree 305cb3ea) is 11
// distinct explicit format strings across 135 pipe sites in 41 files beside
// the en-US default locale rendering; the audit (S30, 2026-09-12) counted
// 15 on its older tree and is superseded. This module collapses the 11 into
// one constant per shape.
//
// The convention, cut U18 (issue #392):
// - FAP_DATE_TIME_FORMAT: every site that renders a date with a time.
// - FAP_DATE_FORMAT: every date-only site. A date-only field rendered with
//   the date-time pattern would show "15.06.2026 00:00" for a backend
//   midnight timestamp, so the shapes stay separate.
// - FAP_TIME_FORMAT: the one time-only site. A time-only countdown rendered
//   with the date-time pattern would show a full date.
//
// Every format stays browser-local (David's ruling of 2026-09-03): no site
// sets a timezone argument until the developer portal.

/** Every site that renders a date with a time (for example the approvals
 *  tab of the work list, "15.06.2026 13:30"). */
export const FAP_DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm';

/** Every date-only site (for example a deadline, "15.06.2026"). */
export const FAP_DATE_FORMAT = 'dd.MM.yyyy';

/** The one time-only site (notification-providers.component.ts, "13:30"). */
export const FAP_TIME_FORMAT = 'HH:mm';
